module.exports = __webpack_public_path__ + "static/media/semantic_language.42c103a3.svg";